import React, { Component } from 'react';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import { Redirect, NavLink,Link} from 'react-router-dom';
import DatePicker from "react-datepicker";
 
import "react-datepicker/dist/react-datepicker.css";



class SpecifyDays extends Component {
    constructor(props)
    {
        super(props);

        this.updateDaysRequested = this.updateDaysRequested.bind(this);
        this.updateStartDate = this.updateStartDate.bind(this);
        this.onClickSubmit = this.onClickSubmit.bind(this);
        this.onClickBack = this.onClickBack.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getReturnDate = this.getReturnDate.bind(this);
        this.initDate = this.initDate.bind(this);

        

        

        this.state = {
            daysRequested:"",
            startDate: new Date(),
            minDate: new Date(),
            returnDate:"",
            tempDate: new Date()

        }
    }


    initDate()
    {
        let topUp = 0;

        let currentDate = new Date();

        if(currentDate.getDay == 6)
        {
            topUp = 2;
        }
        else if(currentDate.getDay == 0)
        {
            topUp = 1;
        }
        else
        {
            topUp = 0;
        }

        return currentDate.setDate(currentDate.getDate + topUp);
    }

    updateDaysRequested(event)
      {
        let dayz = event.target.value;

        if(this.state.startDate != undefined && this.state.startDate != null)
        {
            let rdate = this.getReturnDate(this.state.startDate, dayz)
            
            this.setState({daysRequested:dayz,returnDate:rdate});
        }
        else
        {
            this.setState({daysRequested:dayz}); 
        }

      }

      updateStartDate(date)
      {

        if(this.state.daysRequested != undefined && this.state.daysRequested > 0)
        {
            let rdate = this.getReturnDate(date, this.state.daysRequested)
            
            this.setState({startDate:date,returnDate:rdate});
        }
        else
        {
            this.setState({startDate:date}); 
        }

      }

      onClickSubmit()
      {

        this.props.updateLeaveDetails(this.state.startDate, this.state.daysRequested, this.state.returnDate)

      }

      onClickBack()
      {

        this.props.nullifySelectedLeave();

      }

      handleChange(date) {

        if(this.state.daysRequested != undefined && this.state.daysRequested > 0)
        {
            let rdate = this.getReturnDate(date, this.state.daysRequested)
            
            this.setState({startDate:date,returnDate:rdate});
        }
        else
        {
            this.setState({startDate:date}); 
        }

      }

      getReturnDate(sdate, dayz)
      {
          console.log("received date ", sdate);

          let date = new Date(sdate);

          date.setHours(0,0,0,0);

          console.log("date formatted - ", date);

          while(dayz>0)
          {
              if(date.getDay() != 6 && date.getDay != 0)
              {
                dayz = dayz-1;
              }

              date.setDate(date.getDate()+1);
          }


          return date.toISOString().slice(0, 10);
      }

      componentWillMount()
      {
          /*
        let topUp = 0;

        let currentDate = new Date();

        if(currentDate.getDay == 6)
        {
            topUp = 2;
        }
        else if(currentDate.getDay == 0)
        {
            topUp = 1;
        }
        else
        {
            topUp = 0;
        }

        this.setState({topUp:topUp});
        */
      }

      componentDidMount()
      {
          const _this = this;
          
          if(_this.props.selectedLeave.fixed)
          {
             console.log("did mount");
            let rdate = this.getReturnDate(_this.state.startDate, _this.props.selectedLeave.days)   
            this.setState({returnDate:rdate, daysRequested: _this.props.selectedLeave.days});  
          }

      }


    


  render() {
      const _this = this;
      console.log("selected leave ", this.props.selectedLeave);

    if(this.props.selectedLeave == null || this.props.selectedLeave == undefined)
    {
      return(<Redirect to = "/staff_ui/leave"/>);
    }


    if (this.props.daysRequested>0 && this.props.startDate != "")
    {
        return(<Redirect to = "/staff_ui/leave/downloadform"/>)

    }

    return (
        
        <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 block-centered">
            <h3 className ="center-align">{_this.props.selectedLeave.title + " - "+ _this.props.selectedLeave.days + " days available"}</h3> 
                
                <div className="form-group">
                    <label for="txt-days">How many days do you want to apply for?</label>
                    <input type="number" value = {_this.state.daysRequested}  disabled = {_this.props.selectedLeave.fixed} onChange={_this.updateDaysRequested.bind(_this)}  className="bordered-form-control" id="txt-days"/>
                </div> 

                <div className="form-group">
                    <label for="dt-cont">Pick Start Date </label>
                    <span id ="dt-cont" className="div-form-control">
                        <DatePicker
                                selected={_this.state.startDate}
                                minDate = {_this.state.minDate}
                                filterDate = {this.isWeekday}
                                dateFormat="dd/MM/yyyy"
                                yearDropdownItemNumber = {2}
                                showYearDropdown = {true}
                                id="dt-start"
                                className = "bordered-form-control"
                                scrollableYearDropdown ={true}
                                onChange={this.updateStartDate}/> 
                    </span>
                </div> 

                <div className="form-group">
                    <label for="txt-rdate">Return Date : </label>
                    <input type="text" value = {_this.state.returnDate} disabled="false" className="bordered-form-control" id="txt-rdate"/>
                </div> 

                <div className="form-group">
                    <button type="submit" onClick={_this.onClickBack.bind(_this)} onTap={_this.onClickBack.bind(_this)}  className="btn btn-green col-lg-5 col-md-5 left"> BACK <div className="ripple-container"></div></button>
                    <button type="submit" disabled={_this.state.daysRequested < 1} onClick={_this.onClickSubmit.bind(_this)} onTap={_this.onClickSubmit.bind(_this)}  className="btn btn-green col-lg-5 col-md-5 right"> NEXT <div className="ripple-container"></div></button>
                </div>                 
     
        </div>
    );
  }
}

export default SpecifyDays;
